<template>
  <div class="my-container" v-resize="onResize">
    <img :src="contentUrl" ref='image' @load='contentLoaded'>
    <template v-for="(hs, index) in hotspots">
      <my-hotspot
        :key="index"
        :hs="hs"
        :top='top'
        :left='left'
        :width='width'
        :height='height'
      />
    </template>
    <my-controls v-if="imageLoaded" class='controls' :style="controlsStyle"/>
  </div>
</template>

<script>
import Hotspot from './Hotspot.vue';
import ImageControls from '@/components/controls/ImageControls.vue';

export default {
  data() {
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      imageLoaded: false,
    };
  },
  components: {
    'my-hotspot': Hotspot,
    'my-controls': ImageControls,
  },
  computed: {
    contentUrl() {
      return this.$store.state.project.file;
    },
    hotspots() {
      return this.$store.state.hotspots;
    },
    controlsStyle() {
      return {
        bottom: `${this.top + 10}px`,
        right: `${this.left + 10}px`,
      };
    },
  },
  methods: {
    contentLoaded() {
      this.imageLoaded = true;
      this.onResize();
    },
    onResize() {
      const el = this.$refs.image;
      this.top = Number(window.getComputedStyle(el).getPropertyValue('margin-top').slice(0, -2));
      this.left = Number(window.getComputedStyle(el).getPropertyValue('margin-left').slice(0, -2));
      this.width = Number(window.getComputedStyle(el).getPropertyValue('width').slice(0, -2));
      this.height = Number(window.getComputedStyle(el).getPropertyValue('height').slice(0, -2));
    },
  },
};
</script>

<style scoped>
.my-container {
    width: 100vw;
    height: 100vh;
    background-color:rgba(250, 250, 250, 1);
    display:inline-block;
    /*float:left;*/
    position:relative;
}
.my-container img {
    max-width: 100%;
    max-height:100%;
    margin: auto;
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
}

.controls {
  position: fixed;
  height: 50px;
  bottom: 10px;
  right: 10px;
  z-index: 22;
}
</style>
